import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

type ToastType = 'success' | 'error' | 'warn' | 'info';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  success!: (message: string, duration?: number) => void;
  error!: (message: string, duration?: number) => void;
  warn!: (message: string, duration?: number) => void;
  info!: (message: string, duration?: number) => void;

  constructor(
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    const types: ToastType[] = ['success', 'error', 'warn', 'info'];

    types.forEach(type => {
      this[type] = (message: string, duration?: number) => {
        this.showToast(message, type, duration);
      };
    });
  }

  protected showToast(message: string, type: ToastType, duration = 2500): void {
    this.messageService.add({
      severity: type,
      summary: this.getSummaryForType(type),
      detail: message,
      life: duration
    });
  }

  private getSummaryForType(type: ToastType): string {
    return this.translate.instant(`app.toast.${type}`);
  }
}
